import { useState, useEffect, useCallback } from "react";

export const useAlertMessage = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpen === true) {
      setTimeout(() => {
        setIsOpen(false);
      }, 6000);
    }
  }, [isOpen]);

  const openAlertMessage = useCallback(() => {
    setIsOpen(true);
  }, []);

  const handleClose = useCallback(() => setIsOpen(false), []);

  return { isOpen, openAlertMessage, handleClose };
};
